<h3 vng-dialog-title class="no-left-margin">Duplicate <span class="mat-text-primary font-weight-bold">FlyMSG</span></h3>
<vng-dialog-content>
<form class="clearfix" [formGroup]="form" (ngSubmit)="form.valid && saveShortcut(form.value, 'editor')">
  <div class="fix-height" style="display: flex; flex-direction: column">
    <!-- Shared app-category-select (same recipe as add-shortcut); creation
         stays here via shortcutCategoryRename. -->
    <app-category-select
      #categorySelect
      label="Category"
      [control]="form.controls['category_id']"
      [options]="categoryOptions"
      [error]="
        form.controls['category_id'].invalid &&
        (form.controls['category_id'].dirty || form.controls['category_id'].touched) &&
        form.controls['category_id'].hasError('required')
          ? 'You must select a category.'
          : ''
      "
      (createCategory)="shortcutCategoryRename($event ? { name: $event } : {})"
    ></app-category-select>

    <div class="shortcut-fields-row">
      <vng-input
        label="FlyCut"
        placeholder="FlyCut"
        style="flex: 1 1 100%; max-width: 30%"
        type="text"
        [formControl]="form.controls['shortcut']"
        [flyMsgIgnore]="true"
        [error]="
          form.controls['shortcut'].dirty || form.controls['shortcut'].touched
            ? form.controls['shortcut'].hasError('required')
              ? 'FlyCut is required'
              : form.controls['shortcut'].hasError('notUnique') ? 'This FlyCut already exists' : ''
            : ''
        "
      ></vng-input>

      <vng-input
        label="Title/Description"
        placeholder="Title/Description"
        style="flex: 1 1 100%; max-width: 70%"
        type="text"
        [formControl]="form.controls['title']"
        [flyMsgIgnore]="true"
        [error]="
          (form.controls['title'].dirty || form.controls['title'].touched) &&
          form.controls['title'].hasError('required')
            ? 'Title is required'
            : ''
        "
        info="Your Title/Description is a quick reference reminder of the content inside of the FlyMSG or of your applicable use case. This area is searchable via the search bar in addition to content in your FlyMSG."
      ></vng-input>
    </div>

    <div class="text-title" style="display: flex; justify-content: flex-start; align-items: center; gap: 5px">
      <label for="expanded" class="font-weight-bold">FlyMSG</label>
      <vng-icon
        name="help_center"
        [outline]="false"
        color="purple"
        class="help-icon"
        ngbPopover="The text you create here will automatically replace your FlyCut that you type whenever and wherever you use it."
      >
      </vng-icon>
    </div>
    <editor
      [apiKey]="editorApiKey"
      [cloudChannel]="'8'"
      id="editor"
      [init]="editorConfig"
      (onInit)="setEditorManager($event)"
      *ngIf="editorConfig"
      [hidden]="!isEditorLoaded"
      name="html"
      [formControl]="form.controls['html']"
    >
    </editor>

    <div *ngIf="!isEditorLoaded">
      <div class="animated-background editor-toolbar"></div>
      <div class="animated-background editor-body"></div>
    </div>
    <div *ngIf="form.controls['html'].invalid && (form.controls['html'].dirty || form.controls['html'].touched)">
      <small *ngIf="form.controls['html'].hasError('required')" class="mat-text-warn"
        >You must enter expanded text.</small
      >
    </div>
  </div>

  <div class="top-space" style="display: flex; justify-content: flex-end; align-items: center; gap: 15px">
    <button class="duplicate-shortcut-action" type="button" vng-button variant="outline" tabindex="2" (click)="close()">Cancel</button>
    <button class="duplicate-shortcut-action" type="submit" vng-button variant="primary" tabindex="2" (click)="checkForError()">
      Save FlyMSG
    </button>
  </div>
</form>
</vng-dialog-content>
